import { Component } from "@angular/core";
import { ShareWrapper } from "./share-wrapper.component";
import { environment } from "../../../environments/environment";
import { ActivatedRoute } from "@angular/router";
import { BudgetRevenueShare } from "../../store/reselectors/budget.data";
import { SnapshotInfo } from "globals/store/events.data";
import { doPrint, sleepForMS } from "../../helpers/helpers";
import { BrandingData } from "globals/store/publish.data";
import { BrandingWrapperComponent } from "src/app/components/branding/branding-wrapper.component";
import { BudgetRevenueShareViewComponent } from "../budget/revenue-share-view.component";
import { CommonModule } from "@angular/common";


@Component({
    selector: 'share-revenue',
    template: ` 
<branding-wrapper 
  [brandingData]="brandingData" 
  [style.--sitebackground]="brandingData?.template?.sitebackground || '#ffffff'">
  <div class="content">
    <div *ngIf="loading" class="loading">Loading...</div>
    <ng-container *ngIf="!!budget">
    <budget-revenue-share-view *ngIf="!!budget" [info]="info" [budget]="budget"></budget-revenue-share-view>
    </ng-container>
  </div>
</branding-wrapper>
  `,
    styles: [`
  .content { padding: 40px; margin: 0 auto; }    
`],
    standalone: true,
    imports: [BrandingWrapperComponent, BudgetRevenueShareViewComponent, CommonModule]
})
export class ShareRevenueComponent extends ShareWrapper<ShareRevenueComponent> {

  readonly api = `${environment.functionsURL}api/v1`; // NOTE this is pointing to api/v1 not api/app
  id:string;
  eventId: string
  budget: BudgetRevenueShare
  loading: boolean
  error: string
  info: SnapshotInfo
  print = false
  showPrinting = false
  brandingData: BrandingData

  
  constructor(private route:ActivatedRoute) {
    super()
    this.loading = true;
    document.title = "loading";
    this.route.queryParamMap.subscribe(queryParams => this.print = !!queryParams.get('print'))
    this.route.params.subscribe(params=>{
      console.log({ params })
      if(!params || !params.hasOwnProperty('eventId') || !params.hasOwnProperty('revenueId')) {
        this.loading = false;
        document.title = "Unavailable";
      } else {
        const { eventId, revenueId } = params;
        const url = `${this.api}/load-revenue-share/${eventId}/${revenueId}`
        this.take1(this.http.get(url)).then( async(data: any) => {
          console.log({ data })
          this.budget = JSON.parse(data.budget)
          this.info = data.info
          this.loading = false
          this.brandingData = data.brandingData
          document.title = "Budget Revenue Share"
          if (this.print) {
            await sleepForMS(500)
            doPrint()
          }
        }, (error) => {
          console.log(error)
          this.loading = false;
          document.title = "Budget Revenue Share Unavailable";
        });
      }
    })
  }


}
